import React from 'react';
import { Sparkle } from '../Sparkle/Sparkle';
import * as styles from './SparkleMessage.module.scss';
import { Link, Message } from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  dismissible?: boolean;
  onClose?: () => void;
  className?: string;
  iconStyle?: 'light' | 'solid';
};

export const SparkleMessage = ({
  dismissible = false,
  onClose,
  className,
  iconStyle = 'light',
}: Props) => {
  return (
    <Message
      variant="prominent"
      type="primary"
      icon={false}
      dismissible={dismissible}
      onClose={onClose}
      className={className}
    >
      <Inline spacing={3} shouldWrap={false} alignY="top" alignX="left">
        <span className={styles.sparkleContainer}>
          <Sparkle iconStyle={iconStyle} />
        </span>
        <span className={styles.text}>
          Fields marked with a sparkle offer{' '}
          <strong>automated extraction suggestions</strong> for faster, more
          accurate extraction.{' '}
          <Link
            to="https://support.covidence.org/help/ai-feature-extraction-suggestions"
            variant="primary"
            external={true}
          >
            Accuracy and reporting
          </Link>
        </span>
      </Inline>
    </Message>
  );
};
